import {sanitizeKeyOfValues} from './values'

// Free of `fs`: loadNamespace.ts runs the same transform in the browser

// converts numbered tags in localized strings to the format recognized by next-intl:
// <1>link text</1> -> <tag1>link text</tag1>
function normalizeIndexedTags(str: string): string {
  return str.replace(/<(\d+)>/g, '<tag$1>').replace(/<\/(\d+)>/g, '</tag$1>')
}

// <br /> -> <br></br>
function expandSelfClosingTags(str: string): string {
  return str.replace(/<(\w+)\s*\/>/g, '<$1></$1>')
}

// {{name}} -> {name}
// <1>link text</1> -> <tag1>link text</tag1>
export function transformMessages(messages: Record<string, any>): Record<string, any> {
  return Object.fromEntries(
    Object.entries(messages).map(([key, value]) => {
      if (typeof value === 'string') {
        return [
          key,
          expandSelfClosingTags(
            normalizeIndexedTags(
              value.replace(
                /\{\{(?:- )?([^}]*)\}\}/g,
                (_match, key) => `{${sanitizeKeyOfValues(key)}}`,
              ),
            ),
          ),
        ]
      }
      if (typeof value === 'object' && value !== null) {
        return [key, transformMessages(value)] // recurse into namespaces
      }
      return [key, value]
    }),
  )
}

export function doStripEmptyStrings(messages: Record<string, any>): Record<string, any> {
  return Object.entries(messages).reduce((acc, [key, value]) => {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      acc[key] = doStripEmptyStrings(value)
    } else if (typeof value !== 'string' || value.trim() !== '') {
      acc[key] = value
    }
    // Empty/whitespace strings are simply dropped
    return acc
  }, {} as Record<string, any>)
}
